module.exports = __webpack_public_path__ + "static/media/shaco.66e53632.png";